export var UserModuleNames;
(function (UserModuleNames) {
    UserModuleNames["closed"] = "closed";
    UserModuleNames["account"] = "account";
    UserModuleNames["adressen"] = "adressen";
    UserModuleNames["change_email"] = "change_email";
    UserModuleNames["login"] = "login";
    UserModuleNames["registration"] = "registration";
    UserModuleNames["orders"] = "orders";
    UserModuleNames["reset_password"] = "reset_password";
    UserModuleNames["forgot_username"] = "forgot_username";
    UserModuleNames["forgot_password"] = "forgot_password";
    UserModuleNames["add_address"] = "add_address";
    UserModuleNames["edit_address"] = "edit_address";
    UserModuleNames["logout"] = "logout";
})(UserModuleNames || (UserModuleNames = {}));
//# sourceMappingURL=UserModulesAnimations.js.map